const ArrowRightIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.8371 5.13074C12.6332 4.94456 12.3169 4.95895 12.1307 5.16289C11.9446 5.36683 11.959 5.68309 12.1629 5.86927L18.3307 11.5H4.5C4.22386 11.5 4 11.7239 4 12C4 12.2761 4.22386 12.5 4.5 12.5H18.3279L12.1629 18.1281C11.959 18.3143 11.9446 18.6305 12.1307 18.8345C12.3169 19.0384 12.6332 19.0528 12.8371 18.8666L19.7535 12.5526C19.8934 12.4248 19.9732 12.2573 19.993 12.0841C19.9976 12.0568 20 12.0287 20 12C20 11.9731 19.9979 11.9468 19.9938 11.921C19.9756 11.7451 19.8955 11.5745 19.7535 11.4448L12.8371 5.13074Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ArrowRightIcon;
